import * as React from "react";

function SkypeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M53.85 34.55A21.55 21.55 0 0 0 54 32a22 22 0 0 0-22-22 21.55 21.55 0 0 0-2.55.15 14 14 0 0 0-19.3 19.3A21.55 21.55 0 0 0 10 32a22 22 0 0 0 22 22 21.55 21.55 0 0 0 2.55-.15 14 14 0 0 0 19.3-19.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 26c0-2 0-6-8-6-4 0-8 0-8 6 0 10 16 2 16 12 0 6-4 6-8 6-8 0-8-4-8-6"
  }));
}

export default SkypeIcon;